import React from 'react';

const extractDimensions = (url: string): { width: number; height: number } | null => {
    const m = url.match(/(?:fit|autocrop)\((\d+):(\d+)\)/);
    if (m) {
        return {
            width: parseInt(m[1], 10),
            height: parseInt(m[2], 10),
        };
    }
    return null;
};

const generateMobileUrl = (url: string, mobileWidth: number = 468): string | null => {
    const dims = extractDimensions(url);
    if (!dims) {
        return null;
    }

    const { width, height } = dims;

    if (width < mobileWidth * 1.5) {
        return null;
    }

    const aspectRatio = height / width;
    const mobileHeight = Math.round(mobileWidth * aspectRatio);

    return url.replace(/(fit|autocrop)\(\d+:\d+\)/, (_m, op) => `${op}(${mobileWidth}:${mobileHeight})`);
};

export const preLoadImage = (url: string | null) =>
    new Promise((resolve, reject) => {
        if (!url) {
            reject();
            return;
        }

        const img = new Image();
        img.src = url;
        img.onload = () => resolve(url);
        img.onerror = () => reject();
    });

const S365Picture = ({
    url,
    alt,
    className = '',
    isPriority = false,
    customPlaceHolder,
}: {
    url: string | null;
    alt?: string;
    className?: string;
    isPriority?: boolean;
    customPlaceHolder?: string;
}) => {
    if (!url) {
        return (
            <picture>
                <img
                    className={className}
                    src={customPlaceHolder ?? '/placeholder_main_image.png'}
                    alt={alt}
                    // @ts-expect-error fetchpriority не е дефиниран в типизацията на img
                    fetchpriority={isPriority ? 'high' : 'auto'}
                    loading={isPriority ? 'eager' : 'lazy'}
                    decoding='async'
                />
            </picture>
        );
    }

    const mobileUrl = generateMobileUrl(url);

    return (
        <picture>
            {mobileUrl && (
                <>
                    <source srcSet={mobileUrl} media='(max-width: 767px)' />
                    <source srcSet={`${mobileUrl}&format=webp`} media='(max-width: 767px)' type='image/webp' />
                </>
            )}
            <source srcSet={`${url}&format=webp`} type='image/webp' />
            <img
                className={className}
                src={url}
                alt={alt}
                // @ts-expect-error fetchpriority не е дефиниран в типизацията на img
                fetchpriority={isPriority ? 'high' : 'auto'}
                loading={isPriority ? 'eager' : 'lazy'}
                decoding='async'
            />
        </picture>
    );
};

export default React.memo(S365Picture);
